import { Component, EventEmitter, Inject, Input, Output } from "@angular/core";
import { IDisplaySlide, IDisplaySlideTypeCategory } from "@pcp/core/interfaces";
import { SLIDE_SYNC_UI_CONFIG, SlideSyncUiConfig } from "../../injection-tokens";
import { NgClass } from "@angular/common";
import { MatIconButton } from "@angular/material/button";
import { IconButtonDirective } from 'shared/ui/icon-button';
import { MatIcon } from "@angular/material/icon";
import { TranslocoPipe } from '@jsverse/transloco';


export interface OnAddToFavoritesEvent {
    slide: IDisplaySlide;
    lessonId: null | number;
    slideCategory: IDisplaySlideTypeCategory;
}

export interface AddToFavoritesButtonConfig {
    fontSet: string;
    fontIconChecked: string;
    fontIconUnchecked: string;
}

@Component({
    selector: 'app-add-to-favorites-button',
    templateUrl: './add-to-favorites-button.component.html',
    styleUrls: ['./add-to-favorites-button.component.scss'],
    imports: [MatIconButton, IconButtonDirective, NgClass, MatIcon, TranslocoPipe]
})
export class AddToFavoritesButtonComponent {
    /**
     * Indicates if the current element is added to favorites or not.
     * If yes, the button will have an active class.
     */
    @Input() isFavorite = false;

    /**
     * Disables the button and prevents adding the current element to favorites.
     * No output events will be triggered on click.
     */
    @Input() disabled: boolean = false;

    @Input() scale: number | null = null;

    /**
     * Outputs an event
     */
    @Output() addToFavorites: EventEmitter<MouseEvent> = new EventEmitter();


    readonly fontSet: string;
    readonly fontIconChecked: string;
    readonly fontIconUnchecked: string;

    constructor(@Inject(SLIDE_SYNC_UI_CONFIG) uiConfig: SlideSyncUiConfig) {
        const btnConfig = uiConfig.addToFavoriteButton;
        this.fontSet = btnConfig.fontSet;
        this.fontIconChecked = btnConfig.fontIconChecked;
        this.fontIconUnchecked = btnConfig.fontIconUnchecked;
    }
}
